export function InvoiceDetailInfoItem(label, value) {
  this.label = label || '';
  this.value = value || '';
}
